import { createApp } from 'vue'
import router from './router';
import jQuery from 'jquery';
import 'sweetalert2/dist/sweetalert2.min.css';
import App from './App.vue';
import  VueCookies from 'vue-cookies'

window.$ = window.jQuery = jQuery;
const app = createApp(App);
app.config.globalProperties.$cookies = VueCookies;
app.use(router)
app.use(VueCookies);
app.mount('#app')
router.beforeEach((to, from, next) => {
    if (to.meta.requiresAuth) {
        var userData = JSON.parse(localStorage.getItem("jwtInfo"));
        if (userData) {
            next();
        } else {
            next({
                path: '/FY24_luckydraw',
            })
        }
    } else {
        next();
    }
});
router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
});